/**
 * Normalizes error responses for consistent handling
 * @param {Object} error - The error object from catch block
 * @returns {Object} Normalized error object
 */
export function normalizeError(error) {
    // If it's an axios error response
    if (error.response) {
        return {
            status: error.response.status,
            data: error.response.data,
            message: error.response.data?.message || error.message
        };
    }
    
    // If it's already a response object
    if (error.status) {
        return error;
    }
    
    // For other types of errors
    return {
        status: 500,
        message: error.message || 'An unexpected error occurred',
        data: { errors: { general: [error.message || 'An unexpected error occurred'] } }
    };
}
